import { createContext, useContext } from 'react';

/**
 * Filter Column context
 * @constant {object}
 */

export const FiltersColumnContext = createContext();
/**
 * FiltersColumnContext provider
 * @type object
 */

export const useFiltersColumnContext = () => useContext( FiltersColumnContext );
